import { Grid, Typography } from "@mui/material";
import { styled, lighten } from "@mui/material/styles";

export const EmployeeNameContainer = styled(Grid)({
  "&:hover": {
    cursor: "pointer",
  },
  width: "100%",
  maxWidth: "130px",
  textOverflow: "ellipsis",
  overflow: "hidden",
  // whiteSpace: "nowrap",
});

export const ScheduleCode = styled(Typography)(({ theme }) => ({
  "&:hover": {
    cursor: "pointer",
  },
  fontWeight: 700,
  color: theme.palette.text.primary,
  fontSize: "0.9rem",
}));

export const MainTableContainer = styled(Grid)(({ theme }) => ({
  "& .isWeekend": {
    backgroundColor: lighten(theme.palette.secondary.light, 0.9),
    borderLeft: "1px solid white",
    borderRight: "1px solid white",
  },

  "& .isPublicHoliday": {
    backgroundColor: "pink",
    borderLeft: "1px solid white",
    borderRight: "1px solid white",
  },

  "& .isSignedOff": {
    backgroundColor: lighten(theme.palette.error.light, 0.9),
    borderLeft: "1px solid white",
    borderRight: "1px solid white",
  },

  "& .isOutsideTrackingPeriod": {
    backgroundColor: lighten(theme.palette.grey[500], 0.8),
    borderLeft: "1px solid white",
    borderRight: "1px solid white",
  },
}));

export const AbsencesContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  width: "100%",

  "& > .MuiButton-root": {
    padding: "0px",
  },
});

export const ClientIconContainer = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  gap: "5px",
});

export const CellContainer = styled(Grid)({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  height: "100%",
  // padding: "4px",
});

export const LockIconWrapper = styled("div")(({ theme }) => ({
  position: "absolute",
  top: "2px",
  right: "0px",
  opacity: 0.3,
  color: theme.palette.error.main,
  fontSize: "14px",
}));

export const AnomalyWrapper = styled("div")(({ theme }) => ({
  position: "absolute",
  top: "2px",
  left: "0px",
  opacity: 0.3,
  color: theme.palette.error.main,
  fontSize: "14px",
}));

export const SignedOffContent = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
});

export const HolidayText = styled(Typography)({
  fontSize: "0.75rem",
  textAlign: "center",
  wordBreak: "break-word",
  width: "100%",
});

export const ScheduleHours = styled("span")(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: "0.8rem",
}));

export const PublicHolidayName = styled(Typography)({
  fontSize: "0.75rem",
  textAlign: "center",
  overflow: "hidden",
  textOverflow: "ellipsis",
  // whiteSpace: "nowrap",
  maxWidth: "110px",
});
